module.exports = __webpack_public_path__ + "img/play_icon.62ab8c31.svg";